import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import styled from 'styled-components';
import VerticalBarChart from "../../../../analysis/vertical-bar";
import { pickPercent } from "../../../../analysis/utils";
import { batchRequest } from '../../../../../api/ApiService';
import Teams from '../../../../../api/Teams';

import IconTableHelp from "../../../../../containers/assets/icon-table-help.svg";

const ChartWrapper = styled.div`
  padding: 20px;
`;

const ChartTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.94);
  margin-bottom: 20px;

  ${p => p.isFlex && `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `}

  img {
    display: inline-block;
    width: 14px;
    height: 14px;
    position: relative;
    top: -1px;
    margin-left: 5px;
  }
`;

const ChartData = styled.div`
  max-width: 65%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
`;

class MarketShareStep10 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      teams: [],
      data: [],
    };
  }

  componentDidMount() {
    const { activeRound } = this.props;
    const currentTeam = Teams.currentTeam();
    const competitionId = Number(currentTeam.competition);

    batchRequest([
      `${process.env.REACT_APP_API_URL}teams/`,
      `${process.env.REACT_APP_API_URL}competition/competitive_analysis/?round_number=${activeRound}`,
    ])
      .then(res => {
        const allTeams = res[0].body;
        const teams = allTeams.filter(i => Number(i.competition) === competitionId);

        const competitiveAnalysis = res[1].body;
        const data = pickPercent(teams, competitiveAnalysis, 'Product Awareness');

        this.setState({
          teams,
          data,
        });
      })
      .catch(err => { });
  }

  render() {
    const { teams, data } = this.state;
    const { previousShownErrors } = this.props;

    return (
      <BannerLayout
        section="FEEDBACK"
        subSection="MARKET SHARE"
        previousShownErrors={previousShownErrors}
        alertText="Demand Issue : You have a product with low customer visibility."
        paragraph2={(
          <Fragment>
            You'll need to promote your product to better your chances of capturing more market share.
          </Fragment>
        )}
        visual={(
          <ChartWrapper>
            <ChartTitle>
              Product Awareness
              <img alt="Product Awareness icon help" src={IconTableHelp} />
            </ChartTitle>
            <ChartData>
              <VerticalBarChart
                data={data}
                prefix={""}
                suffix={"%"}
                precision={2}
                customColors={null}
                showCategoryLabels={false}
                instructorData={null}
                teams={teams}
              />
            </ChartData>
          </ChartWrapper>
        )}
      />
    );
  }

}

export default MarketShareStep10;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step10.js